Vue.component('of-header', {
  _scopeId: 'data-v-1b16b1f0',
  owCSS: `.subheader[data-v-1b16b1f0]{display:inline-block;position:relative}.down-arrow[data-v-1b16b1f0]{border-left:5px solid transparent;border-right:5px solid transparent;border-top:5px solid #000;margin-left:5px;top:10px;position:absolute}.reports-tab-content[data-v-1b16b1f0]{display:none;position:absolute;background-color:#fff;z-index:1;height:auto;width:275px;padding:0 8px;box-shadow:0 3px 6px rgba(0,0,0,.175);text-align:left;border:1px solid #ccc;top:70px}.reports-tab-content a[data-v-1b16b1f0]{margin:8px 0!important;font-size:14px!important}.reports-tab-content a[data-v-1b16b1f0]:hover{background-color:#f1f1f1}.dropdown-container:hover .reports-tab-content[data-v-1b16b1f0]{display:block}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}.activeMenu[data-v-1b16b1f0]{left:0!important}.sticky[data-v-1b16b1f0]{position:fixed;z-index:1001;width:100%;top:0;left:0}.show-xs[data-v-1b16b1f0]{display:none!important}header[data-v-1b16b1f0]{background-color:#fff}header.ola-header .pull-left[data-v-1b16b1f0]{float:left}header.ola-header .pull-right[data-v-1b16b1f0]{float:right}header.ola-header .logo[data-v-1b16b1f0]{margin-top:12px;margin-bottom:12px;margin-left:72px}.logo img[data-v-1b16b1f0]{width:84px}.secondary-header[data-v-1b16b1f0]{background:#fff;font-family:Gentona;box-shadow:0 0 1px rgba(0,0,0,.24),0 2px 4px rgba(0,0,0,.12);overflow:visible;text-align:right;transform:translateY(0);z-index:100;width:100%}.secondary-header a[data-v-1b16b1f0]{text-decoration:none;display:inline-block;vertical-align:middle;cursor:pointer}.secondary-header a[data-v-1b16b1f0]:focus{outline:none}.secondary-header .menu-icon[data-v-1b16b1f0]{padding:7px 8px;float:left}.secondary-header .menu-icon[data-v-1b16b1f0]:active,.secondary-header .menu-icon[data-v-1b16b1f0]:focus,.secondary-header .menu-icon[data-v-1b16b1f0]:hover{background:rgba(0,0,0,.08)}.secondary-header .mb-logo .mb-logo-img[data-v-1b16b1f0],.secondary-header .mb-logo[data-v-1b16b1f0]{display:none}.secondary-header .secondary-links a[data-v-1b16b1f0]{font-size:17px;font-weight:500;line-height:24px;color:#000;display:inline-block;vertical-align:middle;cursor:pointer;position:relative;margin:32px 24px 24px}.secondary-header .secondary-links a.activeClass[data-v-1b16b1f0],.secondary-header .secondary-links a[data-v-1b16b1f0]:active,.secondary-header .secondary-links a[data-v-1b16b1f0]:hover{color:#000}.secondary-header .secondary-links a.donate-btn[data-v-1b16b1f0]{border-bottom:none}.secondary-header .secondary-links .active-page[data-v-1b16b1f0]{position:relative;font-weight:500!important}.secondary-header .secondary-links .active-page[data-v-1b16b1f0]:hover{color:rgba(0,0,0,.8);cursor:default}.secondary-header .secondary-links .active-page[data-v-1b16b1f0]:before{content:"";position:absolute;width:70px;height:3px;background:#000;margin:auto;left:0;right:0;bottom:0;display:block}.secondary-header .secondary-links .active-line[data-v-1b16b1f0]{position:absolute;width:70px;height:3px;background:#cce500;margin:auto;left:0;right:0;bottom:0;display:block}.secondary-header .secondary-links .login-link[data-v-1b16b1f0]{position:relative;font-weight:400;background:#cce500;color:rgba(0,0,0,.8);border-radius:2px;margin-top:2px}.secondary-header .secondary-links .login-link[data-v-1b16b1f0]:hover{background:#bdd400;color:#000}.secondary-header .secondary-links .login-link .mid-line[data-v-1b16b1f0]{position:absolute;left:0;height:20px;background:hsla(0,0%,61%,.3);width:1px;top:0;bottom:0;margin:auto}.secondary-header .secondary-links .user-profile-link[data-v-1b16b1f0]{padding:0;margin-left:22px}.secondary-header .secondary-links .user-profile-link img[data-v-1b16b1f0]{width:38px;display:inline-block;vertical-align:middle}.secondary-header .secondary-links .donate-btn[data-v-1b16b1f0]{padding:12px 24px;gap:4px;color:#fff;background:hsla(0,0%,100%,.2);text-align:center;font-size:17px;font-weight:500;display:inline-block;border-radius:0;vertical-align:middle;cursor:pointer;margin-top:16px;margin-bottom:16px!important;margin-right:72px;margin-left:24px;background:#000;line-height:24px}.secondary-header .secondary-links .donate-btn[data-v-1b16b1f0]:hover{background:#ccad08c7;color:#000}.secondary-header .secondary-links .donate-btn[data-v-1b16b1f0]:focus{outline:none}.max-width[data-v-1b16b1f0]{margin:auto}.sidebar_navigation[data-v-1b16b1f0]{width:295px;position:fixed;top:0;left:-100%;background:#fff;height:100%;z-index:12;overflow-x:hidden;opacity:1;transition:.5s ease;-webkit-transition:.5s ease;-moz-transition:.5s ease;-ms-transition:.5s ease;-o-transition:.5s ease;white-space:nowrap;box-shadow:0 0 2px 1px rgba(0,0,0,.2)}.sidebar_navigation .close_btn[data-v-1b16b1f0]{width:40px;height:40px;font-size:32px;line-height:40px;color:#333;float:left;cursor:pointer;text-align:center}.sidebar_navigation .close_btn[data-v-1b16b1f0]:active,.sidebar_navigation .close_btn[data-v-1b16b1f0]:focus,.sidebar_navigation .close_btn[data-v-1b16b1f0]:hover{background:rgba(0,0,0,.08)}.sidebar_navigation ul[data-v-1b16b1f0]{list-style:none;margin:0;padding:0}.sidebar_navigation li a[data-v-1b16b1f0]{width:100%;float:left;padding:15px 20px;color:#4a4a4a;text-decoration:none;font-size:14px}.sidebar_navigation li a[data-v-1b16b1f0]:hover{text-decoration:none;background:rgba(0,0,0,.1)}.sidebar_navigation li a[data-v-1b16b1f0]:focus{outline:none}.overlay-hide[data-v-1b16b1f0]{display:none}@media only screen and (min-device-width:1024px) and (max-device-width:1025px){header.ola-header .logo[data-v-1b16b1f0]{max-width:320px}}@media only screen and (min-width:769px) and (max-width:1100px){.max-width[data-v-1b16b1f0]{padding:0 20px}.secondary-header .secondary-links a[data-v-1b16b1f0]{margin:32px 16px 24px!important}header.ola-header .pull-right[data-v-1b16b1f0]{margin-top:5px;margin-bottom:5px;vertical-align:middle}}@media only screen and (max-width:768px){.secondary-header[data-v-1b16b1f0]{overflow:hidden}.show-xs[data-v-1b16b1f0]{display:block!important}.secondary-header .secondary-links a[data-v-1b16b1f0]{margin:auto}.secondary-header .secondary-links .donate-btn[data-v-1b16b1f0]{margin:auto;margin-right:30px}header.ola-header .logo[data-v-1b16b1f0]{margin:5px}.logo img[data-v-1b16b1f0]{margin-left:50px;width:70px}header.ola-header .pull-left[data-v-1b16b1f0]{width:100%;position:relative}.secondary-header[data-v-1b16b1f0]{position:fixed;width:100%;top:0;z-index:9;padding:0;height:60px;text-align:left}.secondary-header .max-width[data-v-1b16b1f0],.secondary-header .pull-left[data-v-1b16b1f0]{height:100%}.secondary-header .menu-icon[data-v-1b16b1f0]{position:absolute;padding:12px 8px;left:0;top:0;z-index:2}.secondary-header .menu-icon img[data-v-1b16b1f0]{width:24px;height:24px;padding:8px}.secondary-header .mb-logo[data-v-1b16b1f0]{position:absolute;margin:auto;display:block;z-index:2;left:50%;top:12px;transform:translateX(-50%);-webkit-transform:translateX(-50%);-moz-transform:translateX(-50%);-ms-transform:translateX(-50%);-o-transform:translateX(-50%)}.secondary-header .mb-logo .mb-logo-img[data-v-1b16b1f0]{display:inline-block;width:280px;margin-top:4px}.secondary-header .secondary-links .donate-btn[data-v-1b16b1f0]{position:absolute;top:9px;right:0;font-size:14px;font-weight:300;line-height:24px;width:100px;min-width:100px;padding:8px 0}@media only screen and (min-device-width:320px) and (max-device-width:340px){.secondary-header .mb-logo .mb-logo-img[data-v-1b16b1f0]{display:inline-block;width:220px;margin-top:4px}.secondary-header[data-v-1b16b1f0]{overflow:hidden}}}@media only screen and (min-width:769px) and (max-width:1100px){.secondary-header[data-v-1b16b1f0]{height:auto}}`,
  render: function render() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c('header', {
      staticClass: "ola-header sticky"
    }, [_c('div', {
      staticClass: "secondary-header"
    }, [_c('div', {
      staticClass: "max-width"
    }, [_c('div', {
      staticClass: "pull-left"
    }, [_c('a', {
      staticClass: "show-xs menu-icon",
      on: {
        "click": _vm.showMenubar
      }
    }, [_c('img', {
      attrs: {
        "src": "https://s3-ap-southeast-1.amazonaws.com/ola-prod-website/menu.svg",
        "alt": "logmenuo"
      }
    })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('a', {
      staticClass: "logo",
      attrs: {
        "href": "#"
      },
      on: {
        "click": _vm.gotoHome
      }
    }, [_c('img', {
      attrs: {
        "src": "https://s3-ap-southeast-1.amazonaws.com/ola-prod-website/logo-web.png",
        "alt": "logo"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "pull-right",
      attrs: {
        "id": "js-scrollspy"
      }
    }, [_c('div', {
      staticClass: "secondary-links hide-xs"
    }, [_c('a', {
      class: {
        activeClass: _vm.isActive == 1
      },
      attrs: {
        "href": "#about"
      },
      on: {
        "click": function($event) {
          return _vm.gotoHome(1)
        }
      }
    }, [_vm._v("Who we are")]), _vm._v(" "), _c('a', {
      class: {
        activeClass: _vm.isActive == 2
      },
      attrs: {
        "href": "#ourWork"
      },
      on: {
        "click": function($event) {
          return _vm.gotoHome(2)
        }
      }
    }, [_vm._v("Our Work")]), _vm._v(" "), _c('a', {
      class: {
        activeClass: _vm.isActive == 3
      },
      attrs: {
        "href": "#ourStories"
      },
      on: {
        "click": function($event) {
          return _vm.gotoHome(3)
        }
      }
    }, [_vm._v("Stories")]), _vm._v(" "), _c('a', {
      class: {
        activeClass: _vm.isActive == 4
      },
      attrs: {
        "href": "#ourTeam"
      },
      on: {
        "click": function($event) {
          return _vm.gotoHome(4)
        }
      }
    }, [_vm._v("Our Team")]), _vm._v(" "), _c('a', {
      class: {
        activeClass: _vm.isActive == 5
      },
      attrs: {
        "href": "#reachUs"
      },
      on: {
        "click": function($event) {
          return _vm.gotoHome(5)
        }
      }
    }, [_vm._v("Reach us")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('a', {
      class: {
        activeClass: _vm.isActive == 6
      },
      attrs: {
        "href": ""
      },
      on: {
        "click": function($event) {
          return _vm.navigateGallery()
        }
      }
    }, [_vm._v("Gallery")]), _vm._v(" "), _c('a', {
      staticClass: "donate-btn",
      attrs: {
        "href": "#donation"
      },
      on: {
        "click": function($event) {
          return _vm.gotoHome(6)
        }
      }
    }, [_vm._v("Donate")])])]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })])]), _vm._v(" "), _c('div', {
      staticClass: "sidebar_navigation",
      class: [_vm.showMenu ? 'activeMenu' : '']
    }, [_c('a', {
      staticClass: "close_btn",
      on: {
        "click": _vm.hideMenubar
      }
    }, [_vm._v("×")]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    }), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
      directives: [{
        name: "smooth-scroll",
        rawName: "v-smooth-scroll"
      }],
      attrs: {
        "href": "#about"
      },
      on: {
        "click": _vm.hideMenubar
      }
    }, [_vm._v("Who we are")])]), _vm._v(" "), _c('li', [_c('a', {
      directives: [{
        name: "smooth-scroll",
        rawName: "v-smooth-scroll"
      }],
      attrs: {
        "href": "#ourWork"
      },
      on: {
        "click": _vm.hideMenubar
      }
    }, [_vm._v("Our Work")])]), _vm._v(" "), _c('li', [_c('a', {
      directives: [{
        name: "smooth-scroll",
        rawName: "v-smooth-scroll"
      }],
      attrs: {
        "href": "#ourStories"
      },
      on: {
        "click": _vm.hideMenubar
      }
    }, [_vm._v("Stories")])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('li', [_c('a', {
      directives: [{
        name: "smooth-scroll",
        rawName: "v-smooth-scroll"
      }],
      attrs: {
        "href": "#ourTeam"
      },
      on: {
        "click": _vm.hideMenubar
      }
    }, [_vm._v("Our Team")])]), _vm._v(" "), _c('li', [_c('a', {
      directives: [{
        name: "smooth-scroll",
        rawName: "v-smooth-scroll"
      }],
      attrs: {
        "href": "#reachUs"
      },
      on: {
        "click": _vm.hideMenubar
      }
    }, [_vm._v("Reach Us")])]), _vm._v(" "), _c('li', [_c('a', {
      directives: [{
        name: "smooth-scroll",
        rawName: "v-smooth-scroll"
      }],
      attrs: {
        "href": ""
      },
      on: {
        "click": function($event) {
          return _vm.navigateGallery()
        }
      }
    }, [_vm._v("Gallery")])])])])])
  },
  staticRenderFns: [function render() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c('a', {
      staticClass: "logo show-xs",
      attrs: {
        "href": "#"
      }
    }, [_c('img', {
      attrs: {
        "src": "https://s3-ap-southeast-1.amazonaws.com/ola-prod-website/logo.png",
        "alt": "logo"
      }
    })])
  }, function render() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c('div', {
      staticClass: "subheader dropdown-container"
    }, [_c('a', [_vm._v(" Reports "), _c('span', {
      staticClass: "down-arrow"
    })]), _vm._v(" "), _c('div', {
      staticClass: "reports-tab-content"
    }, [_c('ul', [_c('li', [_c('a', {
      attrs: {
        "href": "https://s3-ap-southeast-1.amazonaws.com/ola-prod-website/Ola-Foundation-Impact-Report-April-20-To-March-22.pdf",
        "target": "_blank"
      }
    }, [_vm._v("Ola-Foundation-Impact-Report-2020 - 2022")])]), _vm._v(" "), _c('li', [_c('a', {
      attrs: {
        "href": "https://s3-ap-southeast-1.amazonaws.com/ola-prod-website/Ola-Foundation-Impact-Report-April-20-To-June-20.pdf",
        "target": "_blank"
      }
    }, [_vm._v("Ola-Foundation-Impact-Report- 2020")])])])])])
  }, function render() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c('li', [_c('a', {
      attrs: {
        "href": "https://s3-ap-southeast-1.amazonaws.com/ola-prod-website/Ola-Foundation-Impact-Report-April-20-To-March-22.pdf",
        "target": "_blank"
      }
    }, [_vm._v("Ola-Foundation-Impact-Report-2020 - 2022")])])
  }, function render() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c('li', [_c('a', {
      attrs: {
        "href": "https://s3-ap-southeast-1.amazonaws.com/ola-prod-website/Ola-Foundation-Impact-Report-April-20-To-June-20.pdf",
        "target": "_blank"
      }
    }, [_vm._v("Ola-Foundation-Impact-Report- 2020")])])
  }],

  name: "ofHeader",
  props: {
    activeIndex: {
      type: Boolean,
      default: null
    }
  },
  data: function data() {
    return {
      showMenu: false,
      isActive: 0
    };
  },
  mounted: function mounted() {
    if (this.activeIndex != null) {
      this.isActive = this.activeIndex;
    }
  },

  methods: {
    trackEvent: function trackEvent(name) {
      var url = 'https://apps.olacabs.com/web/event/publish?eventName=' + name + '&eventValue=';
      var obj = {
        "timestamp": new Date()
      };
      url = url + JSON.stringify(obj);
      new Image().src = url;
    },
    showMenubar: function showMenubar(evt) {
      this.showMenu = true;
    },
    gotoHome: function gotoHome(index) {
      this.isActive = index;
      this.$store.commit("SET_HEADER_INDEX", index);
      if (index === 0) {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
      }
      this.$router.push("/");
      if (index === 6) {
        this.trackEvent('reach_out_clicked');
      }
    },
    navigateDonate: function navigateDonate(index) {
      this.isActive = index;
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      this.showMenu = false;
      this.$router.push("/donate");
    },
    navigateDriverFund: function navigateDriverFund(index) {
      this.isActive = index;
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      this.showMenu = false;
      this.$router.push("/drive-the-driver");
    },
    navigateGallery: function navigateGallery(index) {
      this.isActive = index;
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      this.showMenu = false;
      this.$router.push("/gallery");
    },
    hideMenubar: function hideMenubar(evt) {
      if (evt) {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
      }
      this.showMenu = false;
      this.$router.push("/");
    }
  },
  watch: {}

});